import Cookies from 'js-cookie'
import {login, logout} from '@/utils/api/login.js'
import {Message} from 'element-ui'

const state = {
  token: '',
  userInfo: null
}

const getters = {
  getToken (state) {
    return state.token
  },
  getUserInfo (state) {
    return state.userInfo
  }
}

const mutations = {
  setToken (state, payload) {
    state.token = payload
  },
  setUserInfo (state, payload) {
    state.userInfo = payload
  }
}

const actions = {
  login ({commit}, config) {
    let expires = 15
    return new Promise((resolve, reject) => {
      login(config).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  logout ({ commit }, config) {
    return new Promise((resolve, reject) => {
      logout().then(res => {
        Cookies.set('token', res.data.token, {expires: -1})
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/module/auth.js